import { dropdownCategory } from '../../../common/const'

export const fieldNames = {
  maxLoadCap: {
    label: 'VEHICLE_COMMON_MAXIMUM-LOAD-CAPACITY_LABEL',
    name: 'maxLoadCapacity',
    type: 'number',
    tabIndexes: [6, 7]
  },
  length: {
    label: 'VEHICLE_COMMON_LENGTH_LABEL',
    name: 'length',
    type: 'number',
    tabIndexes: [12, 13]
  },
  frontFrontAxleLoad: {
    label: 'VEHICLE_COMMON_FF-AXLE-LOAD_LABEL',
    name: 'frontFrontAxleLoad',
    type: 'number',
    tabIndexes: [18, 19]
  },
  rearRearAxleLoad: {
    label: 'VEHICLE_COMMON_RR-AXLE-LOAD_LABEL',
    name: 'rearRearAxleLoad',
    type: 'number',
    tabIndexes: [24, 25]
  },
  frontRearAxleLoad: {
    label: 'VEHICLE_COMMON_FR-AXLE-LOAD_LABEL',
    name: 'frontRearAxleLoad',
    type: 'number',
    tabIndexes: [20, 21]
  },
  rearFrontAxleLoad: {
    label: 'VEHICLE_COMMON_RF-AXLE-LOAD_LABEL',
    name: 'rearFrontAxleLoad',
    type: 'number',
    tabIndexes: [22, 23]
  },
  seatingCap: {
    label: 'VEHICLE_COMMON_SEATING-CAPACITY_LABEL',
    name: 'seatingCapacity',
    type: 'number',
    tabIndexes: [4, 5]
  },
  vehicleWeight: {
    label: 'VEHICLE_COMMON_VEHICLE-WEIGHT_LABEL',
    name: 'vehicleWeight',
    type: 'number',
    tabIndexes: [8, 9]
  },
  grossVehicleWeight: {
    label: 'VEHICLE_COMMON_GROSS-VEHICLE-WEIGHT_LABEL',
    name: 'grossVehicleWeight',
    type: 'number',
    tabIndexes: [10, 11]
  },
  width: {
    label: 'VEHICLE_COMMON_WIDTH_LABEL',
    name: 'width',
    type: 'number',
    tabIndexes: [14, 15]
  },
  height: {
    label: 'VEHICLE_COMMON_HEIGHT_LABEL',
    name: 'height',
    type: 'number',
    tabIndexes: [16, 17]
  }
}

export const advancedSearchOptions = [
  { value: 'modelDesignationNumber', label: 'VEHICLE_COMMON_MODEL-DESIGNATION-NUMBER_LABEL', type: 'text', maxLength: '255', selected: false },
  { value: 'classificationCategoryNumber', label: 'VEHICLE_COMMON_CLASSIFICATION-CATEGORY-NUMBER_LABEL', type: 'text', maxLength: '255', selected: false },
  { value: 'batteryType', label: 'VEHICLE_COMMON_BATTERY-TYPE_LABEL', type: 'text', maxLength: '255', selected: false },
  { value: 'batteryReplacementDate', label: 'VEHICLE_COMMON_BATTERY-REPLACEMENT-DATE_LABEL', type: 'date', maxLength: '', selected: false },
  { value: 'transmission', label: 'VEHICLE_COMMON_TRANSMISSION_LABEL', type: 'dropdown', maxLength: '', options: dropdownCategory.transmission, selected: false },
  { value: 'cabinColor', label: 'VEHICLE_COMMON_CABIN-COLOR_LABEL', type: 'dropdown', maxLength: '', options: dropdownCategory.cabinColor, selected: false },
  { value: 'bodyColor', label: 'VEHICLE_COMMON_BODY-COLOR_LABEL', type: 'text', maxLength: '255', selected: false },
  { value: 'sbsMarking', label: 'VEHICLE_COMMON_SBS-MARKING_LABEL', type: 'dropdown', maxLength: '', options: dropdownCategory.sbsMarking, selected: false },
  { value: 'aoriHeight', label: 'VEHICLE_COMMON_AORI-HEIGHT_LABEL', type: 'number', maxLength: '10', selected: false },
  { value: 'lashingRailPosition', label: 'VEHICLE_COMMON_LASHING-RAIL-POSITION_LABEL', type: 'text', maxLength: '255', selected: false },
  { value: 'tireManufacturer', label: 'VEHICLE_COMMON_TIRE-MANUFACTURER_LABEL', type: 'dropdown', maxLength: '', options: dropdownCategory.tireManufacturer, selected: false },
  { value: 'tireChain', label: 'VEHICLE_COMMON_TIRE-CHAIN_LABEL', type: 'dropdown', maxLength: '', options: dropdownCategory.tireChain, selected: false },
  { value: 'spareTire', label: 'VEHICLE_COMMON_SPARE-TIRE_LABEL', type: 'dropdown', maxLength: '', options: dropdownCategory.spareTire, selected: false },
  { value: 'tireSizeFront', label: 'VEHICLE_COMMON_TIRE-SIZE-FRONT_LABEL', type: 'text', maxLength: '255', selected: false },
  { value: 'tireSizeFrontRear', label: 'VEHICLE_COMMON_TIRE-SIZE-FRONT-REAR_LABEL', type: 'text', maxLength: '255', selected: false },
  { value: 'tireSizeRearFront', label: 'VEHICLE_COMMON_TIRE-SIZE-REAR-FRONT_LABEL', type: 'text', maxLength: '255', selected: false },
  { value: 'tireSizeRear', label: 'VEHICLE_COMMON_TIRE-SIZE-REAR_LABEL', type: 'text', maxLength: '255', selected: false }
]
